import { siteConfig } from '@/configs/siteConfig';

// import { siteState } from '@/modules/siteState/siteStateGetter';

const props = {
  className: 'js-scrollGuide',
} as const;

export const scrollGuideManager = {
  init() {
    const els = document.querySelectorAll<HTMLElement>(`.${props.className}`);

    els.forEach((el) => {
      el.addEventListener('scroll', this.onScroll, { passive: true });
    });
  },

  onScroll: (e: Event) => {
    const el = e.currentTarget as HTMLElement;

    if (el.scrollLeft > 0) {
      el.classList.add(siteConfig.class.act);
      el.removeEventListener('scroll', scrollGuideManager.onScroll);
    }
  },
};
